import React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import Button from '../../../../../../../../components/button/index';
import {
	findCollaborators,
	flash,
	getSharingDetailsPopup
} from '../../../../../../../../../actions/sharingDetailsActions';
import {msgBar} from '../../../../../../../../../actions/msgBarActions';
import './index.css';

class SharingLabelButton extends React.Component {

	constructor(props) {
		super(props);

		this.shareHandler = this.shareHandler.bind(this);
	}

	shareHandler(e) {

		if (this.props.sharingDetailsPopup[1] === 'contact_details') {

			if (!e.currentTarget.dataset.disabled) {

				if (document.querySelector('.slide.new-contact-details-popup')) {
					document.querySelector('.slide.new-contact-details-popup').style.left = '-768px';

					/*
					* Because add_collaborator_popup content is already loaded thus, it didn't trigger its componentDidMount, so we need to trigger the collaborators list manually
					* */

					if(this.props.labelType === "system"){
						this.props.setFindCollaborators(6, this.props.collaboratorsPageSize);
					} else {
						this.props.setFindCollaborators(this.props.labelId, this.props.collaboratorsPageSize);
					}

				}

			} else {
				e.currentTarget.style.cursor = 'not-allowed';
				setTimeout(() => {
					if (this.props.selectedContactsGroup.permission === 'WRITE_ONLY') {
						this.props.msgBar(['error', this.props.t('textErrorPermission1')])

					} else if (this.props.selectedContactsGroup.permission === 'WRITE_DELETE') {
						this.props.msgBar(['error', this.props.t('textErrorPermission2')])
					} else {
						this.props.msgBar(['error', this.props.t('msgBarErrorText5')])
					}
				}, 10)

			}
		} else {
			if (!e.currentTarget.dataset.disabled) {
				if (this.props.profile.status.includes('invited')) {
					this.props.getSharingDetailsPopup([true, 'choose_plan']);
				} else {
					if(this.props.labelId){
						if(this.props.labelType === "system") {
							this.props.getSharingDetailsPopup([true, 'add_user', 6, this.props.labelName]);
						} else {
							this.props.getSharingDetailsPopup([true, 'add_user', this.props.labelId, this.props.labelName]);
						}
					} else {
						this.props.getSharingDetailsPopup([true, 'add_user']);
					}

				}

				if(this.props.flash !== null){
					this.props.setFlash([]);
				}

			} else {
				e.currentTarget.style.cursor = 'not-allowed';
				setTimeout(() => {
					if(this.props.selectedContactsGroup){
						if (this.props.selectedContactsGroup.permission === 'WRITE_ONLY') {
							this.props.msgBar(['error', this.props.t('textErrorPermission1')])
						} else if (this.props.selectedContactsGroup.permission === 'WRITE_DELETE') {
							this.props.msgBar(['error', this.props.t('textErrorPermission2')])
						} else if (this.props.selectedContactsGroup.type === 'directory' && this.props.findDirectoryGroups.state === 'RUNNING') {
							this.props.msgBar(['error', this.props.t('textErrorDirectorySycningShare')])
						} else if (this.props.selectedContactsGroup.type === 'directory' && this.props.selectedContactsGroup.activeDirectory === false) {
							this.props.msgBar(['error', this.props.t('textErrorDirectoryNotSynced')])
						} else if (
							this.props.selectedContactsGroup.type === 'directory'
							&& this.props.selectedContactsGroup.activeDirectory === true
							&& this.props.selectedContactsGroup.directoryDisplayStatus === "DIRECTORY_LABEL_NOT_SHARED_ADMIN"
						) {
							this.props.msgBar(['error', this.props.t('textErrorDirectoryLabelNotSharedAdmin')])
						} else if (this.props.selectedContactsGroup.type === 'directory' && this.props.profile.domain?.plan !== 'BUSINESS') {
							this.props.msgBar(['error', this.props.t('textErrorDirectoryUpgrade')])
						} else {
							this.props.msgBar(['error', this.props.t('msgBarErrorText5')])
						}
					} else {
						this.props.msgBar(['error', this.props.t('msgBarErrorText5')])
					}
				}, 10)
			}
		}

	}

	render() {
		return (
			<Button className="p-0 sharing-label-button" onClick={this.shareHandler} data-disabled={this.props.disabled}
			        aria-disabled={this.props.disabled} title={this.props.title}>
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g>
						<path fill="#4CC2F1"
						      d="M16,31C7.729,31,1,24.271,1,16C1,7.729,7.729,1,16,1c8.271,0,15,6.729,15,15C31,24.271,24.271,31,16,31z"/>
						<path fill="#FFFFFF" d="M16,2c7.72,0,14,6.28,14,14s-6.28,14-14,14S2,23.72,2,16S8.28,2,16,2 M16,0C7.164,0,0,7.164,0,16
		c0,8.837,7.164,16,16,16c8.837,0,16-7.163,16-16C32,7.164,24.837,0,16,0L16,0z"/>
					</g>
					<g>
						<line fill="none" stroke="#FFFFFF" strokeMiterlimit="10" x1="12.519" y1="17.156" x2="17.48"
						      y2="20.076"/>
						<line fill="none" stroke="#FFFFFF" strokeMiterlimit="10" x1="12.519" y1="14.843" x2="17.48"
						      y2="11.924"/>
						<circle fill="#FFFFFF" cx="19.793" cy="10.708" r="2.677"/>
						<circle fill="#FFFFFF" cx="19.793" cy="21.292" r="2.677"/>
						<circle fill="#FFFFFF" cx="10.207" cy="16.061" r="2.677"/>
					</g>
				</svg>
			</Button>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		profile: state.profileReducer.getProfile,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
		findDirectoryGroups: state.directoryGroupReducer.findDirectoryGroups,
		flash: state.sharingDetailsReducer.flash
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setFindCollaborators: (selectedLabelId, pageSize, refresh) => {
			dispatch(findCollaborators(selectedLabelId, pageSize, refresh))
		},
		getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		msgBar: (array) => {
			dispatch(msgBar(array))
		},
		setFlash: (array) => {
			dispatch(flash(array))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SharingLabelButton));
